import { ROUTE_TO_SCHEDULER } from "./actionTypes";

export const routeToScheduler = () => {
  return {
    type: ROUTE_TO_SCHEDULER
  };
};
